export default "__VITE_ASSET__BO5GY30s__"